import React from 'react';
import ReactDOM from 'react-dom/client';
import './css/index.css';
import App from './App';
import { TAB_DISPLAY_NAME } from './constants/bookingConst';
import reportWebVitals from './reportWebVitals';

// public/index.html already carries the name, substituted from
// REACT_APP_TAB_DISPLAY_NAME at build time. This only rescues the case where that
// variable is unset: Create React App then leaves the literal
// "%REACT_APP_TAB_DISPLAY_NAME%" sitting in the tab rather than blanking it,
// which is a worse thing to show than a sensible default. Checked rather than
// assigned unconditionally, so the .env value stays the source of truth
// whenever there is one.
if (!document.title || document.title.includes('%')) {
  document.title = TAB_DISPLAY_NAME;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
